import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { BULK_RPC_MAP, SINGLE_RPC_MAP } from './rpcMethods';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const getSuspensionStatus = (contentId, keyWord, hasRpcGate = false) => {
  if (hasRpcGate) {
    return rpcClient.call(SINGLE_RPC_MAP[keyWord], {
      request: {
        contentId: String(contentId)
      }
    });
  }
  return http.get(`abuse-desk-public/v2/content-case/moderation-status/${keyWord}/${contentId}`);
};
export const getBulkSuspensionStatus = (contentIds, keyWord, hasRpcGate = false) => {
  if (hasRpcGate) {
    return rpcClient.call(BULK_RPC_MAP[keyWord], {
      request: {
        contentIds: contentIds.map(String)
      }
    }).then(response => response.moderationStatuses);
  }
  return http.get(`abuse-desk-public/v1/content-case/moderation-status/${keyWord}`, {
    query: {
      contentIds
    }
  });
};
export const getHubContentReviewStatus = contentId => {
  console.log(contentId);
  return Promise.resolve({
    reviewState: 'IN_REVIEW',
    portalLevel: 'ENTERPRISE',
    slaCopyType: 'NON_CORE'
  });
};